import { useEffect, useRef } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function AdPlaceholder({
  variant = "inline",
  label = "Advertisement",
  testId = "ad-placeholder",
}) {
  const { settings } = useSettings();
  const pubId = settings.google_adsense_publisher_id;
  const slot =
    variant === "sidebar"
      ? settings.google_adsense_slot_sidebar
      : settings.google_adsense_slot_inline;
  const insRef = useRef(null);

  // When configured, push the ad to AdSense queue
  useEffect(() => {
    if (!pubId || !slot || !insRef.current) return;
    try {
      // eslint-disable-next-line no-undef
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // adsbygoogle script not loaded yet — context will inject it
    }
  }, [pubId, slot]);

  const baseClass =
    variant === "sidebar"
      ? "w-full min-h-[600px]"
      : "w-full min-h-[120px] my-6";

  // Real ad mode
  if (pubId && slot) {
    return (
      <div className={baseClass} data-testid={testId} data-ad-slot={variant}>
        <ins
          ref={insRef}
          className="adsbygoogle"
          style={{ display: "block", width: "100%", height: variant === "sidebar" ? "600px" : "120px" }}
          data-ad-client={pubId}
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    );
  }

  // Placeholder mode
  return (
    <div
      data-testid={testId}
      data-ad-slot={variant}
      className={`${baseClass} rounded-md flex items-center justify-center text-xs uppercase tracking-widest`}
      style={{
        border: "1px dashed var(--jaf-border)",
        backgroundColor: "var(--jaf-surface)",
        color: "var(--jaf-text-muted)",
      }}
    >
      <span>
        {label} · Google AdSense ({variant})
        {pubId && !slot && (
          <span className="block normal-case tracking-normal text-[10px] mt-1">
            Set the {variant} slot ID in admin settings to activate
          </span>
        )}
      </span>
    </div>
  );
}
